import styled from '@emotion/styled';
import React, { PropsWithChildren } from 'react';
import ContentTitle from 'components/base/ContentTitle';
import { border4 } from 'styles';

/**
 * 검색 필터 - 필터 섹션
 * @component
 */
interface Props extends PropsWithChildren {
  title: string;
  use_line?: boolean;
}
const SearchSection = React.forwardRef<HTMLElement, Props>(({ title, use_line = true, children }, ref) => {
  return (
    <SC.Container ref={ref}>
      <ContentTitle size='large' title={title} />
      <div className='content'>{children}</div>
      {use_line && <SC.Line />}
    </SC.Container>
  );
});

export default SearchSection;

const SC = {
  Container: styled.section`
    padding-top: 48px;
    margin-top: -48px;
    .content {
      padding: 0 16px 16px;
    }
  `,
  Line: styled.hr`
    border: none;
    border-bottom: 1px solid ${border4};
    padding: 0 2px;
  `,
};
